// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__D1nH2","noBorder":"Panel_noBorder__CZlaa"};